<template>
  <!-- P云 banner：容器始终挂载供 SDK 写入，仅加载成功后展示 -->
  <div
    v-show="adVisible"
    class="adBox pyun-banner-ad"
    :id="containerId"
  ></div>
</template>
<script>
import { loadPyunSdk, getPyunInstance } from '../../api/pyunSdk'
import { pyunAppId, pyunProviderUrl, pyunExternal } from '../../../config/pyunConfig'
import { logger } from '../../api/pyunLogger'

let adCounter = 0

export default {
  name: 'ad_pcloud',
  props: {
    spaceId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      containerId: 'pyun-banner-' + (++adCounter),
      adVisible: false
    }
  },
  methods: {
    async loadAd () {
      try {
        const sid = this.$store.state.sid.sid
        logger.info('[PyunBanner] 开始加载广告, spaceId:', this.spaceId, 'provider_code:', sid, 'el:', this.containerId)

        await this.$nextTick()

        await loadPyunSdk()
        const pyun = getPyunInstance()
        if (!pyun || typeof pyun.advertingPull !== 'function') {
          logger.error('[PyunBanner] SDK未加载')
          this.$emit('failed', new Error('SDK未加载'))
          return
        }

        const self = this
        pyun.advertingPull({
          el: self.containerId,
          app_id: pyunAppId,
          openid: self.$store.getters.openID || '',
          space_id: self.spaceId,
          displayed: 1,
          provider_code: sid || '',
          external: pyunExternal,
          provider_url: pyunProviderUrl,
          personas: {},
          success: function (data) {
            logger.info('[PyunBanner] 广告加载成功', data)
            self.adVisible = true
            self.$emit('loaded', data)
          },
          failure: function (cause) {
            const msg = cause && (cause.message || cause.msg) ? (cause.message || cause.msg) : String(cause || '加载失败')
            logger.error('[PyunBanner] 广告加载失败', cause)
            self.adVisible = false
            self.$emit('failed', cause || new Error(msg))
          }
        })
      } catch (err) {
        logger.error('[PyunBanner] 加载异常', err)
        this.adVisible = false
        this.$emit('failed', err)
      }
    }
  },
  mounted () {
    if (this.spaceId) {
      this.loadAd()
    } else {
      logger.warn('[PyunBanner] spaceId为空，跳过加载')
      this.$emit('failed', new Error('spaceId为空'))
    }
  }
}
</script>

<style scoped>
.adBox {
  width: 100%;
  min-height: 0;
}
</style>
